import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { isAdministrativeProvider, isSupervisingPhysician, isExecutive } from '../../../store/current-user/CurrentUserSelectors';

class ReviewForm extends React.Component {
  static propTypes = {
    view: PropTypes.string,
    flags: PropTypes.object,
    editFlagsMode: PropTypes.bool,
    toggleNotes: PropTypes.func,
    onSubmit: PropTypes.func,
    visitNoteID: PropTypes.number,
  };

  renderToggler = props => (
    <label className="checkbox-inline">
      <input type="checkbox" {...props.input} /> {props.label}
    </label>
  );

  renderTextarea = ({
    input,
    label,
    type,
    meta: { touched, error, warning, invalid },
  }) => (
    <div className={touched && invalid ? 'has-error' : ''}>
      <label>{label}</label>
      <div>
        <textarea
          {...input}
          rows="5"
          placeholder={label}
          type={type}
          className={`form-control`}
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  onStatusChange = (name, value) => {
    this.props.change(name, !value);
  };

  submit = values => {
    const { editFlagsMode, onSubmit, reset } = this.props;
    const actionValues = {};
    if (editFlagsMode) {
      actionValues.clearMskFlag = values.clearMskFlag;
      actionValues.setMskFlag = values.setMskFlag;
      actionValues.note = values.note;
      actionValues.target = 'msk';
    } else {
      actionValues.note = values.note;
      actionValues.setFollowUp = values.setFollowUp;
      actionValues.markReviewed = values.markReviewed;
      actionValues.markResolved = values.markResolved;
    }
    if (this.props.initialValues.visitNoteID) {
      actionValues.visitNoteID = this.props.initialValues.visitNoteID;
    }
    return onSubmit(actionValues).then(() => {
      reset();
    });
  };

  render() {
    const {
      toggleNotes,
      view,
      handleSubmit,
      pristine,
      submitting,
      isAdministrativeProvider,
      isSupervisingPhysician,
      editFlagsMode,
      flags,
      isLoading,
      isExecutive,
    } = this.props;

    return (
      <form className="review-notes-form" onSubmit={handleSubmit(this.submit)}>
        <fieldset>
          <legend>
            {editFlagsMode ? 'MSK Protocol Notes' : 'Review Notes'}
          </legend>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <Field
                  name="note"
                  className="form-control"
                  component={this.renderTextarea}
                  label="Content"
                />
              </div>
            </div>
          </div>
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-sm-8">
              <div className="text-left">
                {editFlagsMode && flags.mskFlag === 'Y' && (
                  <div>
                    <Field
                      name="clearMskFlag"
                      className="form-control"
                      component={this.renderToggler}
                      label="Clear MSK Flags"
                      btnClass="btn-info"
                      icon="glyphicon-bookmark"
                    />{' '}
                  </div>
                )}
                {editFlagsMode && flags.mskFlag === 'N' && (
                  <div>
                    <Field
                      name="setMskFlag"
                      className="form-control"
                      component={this.renderToggler}
                      label="Set MSK Flags"
                      btnClass="btn-info"
                      icon="glyphicon-bookmark"
                    />{' '}
                  </div>
                )}
                {!editFlagsMode && (
                  <div>
                    <Field
                      name="setFollowUp"
                      className="form-control"
                      component={this.renderToggler}
                      label="Set for Follow-Up"
                      btnClass="btn-info"
                      icon="glyphicon-bookmark"
                    />{' '}
                    {(view === 'CHART_REVIEW' || view === 'CPT_REVIEW')  && (isAdministrativeProvider || isSupervisingPhysician) && (
                      <Field
                        name="markReviewed"
                        className="form-control"
                        component={this.renderToggler}
                        label="Mark Reviewed"
                        btnClass="btn-success"
                        icon="glyphicon-comment"
                      />
                    )}{' '}
                    <Field
                      name="markResolved"
                      className="form-control"
                      component={this.renderToggler}
                      label="Mark Resolved"
                      btnClass="btn-default"
                      icon="glyphicon-check"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-4">
              <button
                type="button"
                className="btn btn-default"
                onClick={() => toggleNotes()}
                disabled={submitting}
              >
                Cancel
              </button>
              &nbsp;
              <button
                type="submit"
                className="btn btn-primary"
                disabled={pristine || submitting || isExecutive}
              >
                {editFlagsMode ? 'Submit' : 'Post Review'}
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="cover">
            <div className="spinner inline" />
          </div>
        )}
      </form>
    );
  }
}
const validate = (values, props) => {
  const errors = {};
  if (
    !props.editFlagsMode ||
    (props.editFlagsMode && props.flags.mskFlag === 'N')
  ) {
    if (!values.note) {
      errors.note = 'Required';
    }
  }
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  return {
    isAdministrativeProvider: isAdministrativeProvider(state),
    isSupervisingPhysician: isSupervisingPhysician(state),
    isExecutive: isExecutive(state),
    initialValues: {
      note: '',
      setFollowUp: false,
      markReviewed: false,
      markResolved: false,
      clearMskFlag: false,
      setMskFlag: false,
      visitNoteID: ownProps.visitNoteID,
    },
    validate,
    form: `reviewForm_${ownProps.visitNoteID}`
  };
}
export default compose(
  connect(mapStateToProps),
  reduxForm({
      //other redux-form options...
  })
)(ReviewForm);



// WEBPACK FOOTER //
// ./src/routes/management/components/ReviewForm.js